import React from 'react';

import reactjsImg from '../../assets/reactjs.svg';
import reactnativeImg from '../../assets/react-native.svg';
import nodejsImg from '../../assets/nodejs.svg';
import wordpressImg from '../../assets/wordpress.svg';

import Background from '../../components/Background';
import Header from '../../components/Header';

import { Container, Wrapper, Content } from './styles';

const About: React.FC = () => (
  <Wrapper>
    <Container>
      <Background />
      <Header />

      <Content>
        <span>Hi, my name is</span>
        <h1>Gabriel Menezes</h1>

        <p>
          I have been working with Design for 3 years, and throughout my career
          I have been able to work in several areas of Design such as: Motion
          Design, Visual Design, Art Direction and even Animation. I always
          worked with design, because after my first computer I found myself
          exploring this world of photo editing and building compositions within
          Photoshop and playing with 3D in Cinema 4D.
        </p>

        <p>
          A few years later I had the challenge of making a website for a course
          completion project, and that was where I definitely fell in love with
          the Programming area. In the last 2 years I have also dedicated myself
          to UI in the companies and projects I worked on, and today I work as a
          Front-End Developer at Estudio La.Bomba, one of the best Design
          studios in ABC.
        </p>

        <section>
          <span>technologies</span>
          <ul className="techs">
            <li>
              <img src={reactjsImg} alt="React.js" />
              <p>React.js</p>
            </li>
            <li>
              <img src={reactnativeImg} alt="React Native" />
              <p>React Native</p>
            </li>
            <li>
              <img src={nodejsImg} alt="Node.js" />
              <p>Node.js</p>
            </li>
            <li>
              <img src={wordpressImg} alt="Wordpress" />
              <p>Wordpress</p>
            </li>
          </ul>
        </section>

        <div className="footer">
          <div>
            <h4>Social Links</h4>
            <ul>
              <a href="https://www.linkedin.com/in/mnzs/" target="blank">
                Linkedin
              </a>
              <a href="https://www.github.com/mnzsss" target="blank">
                Github
              </a>
              <a href="mailto:job@mnzs.dev">E-mail</a>
            </ul>
          </div>
          <div>
            <h4>Living In</h4>
            <p>São Paulo, SP - Brasil</p>
          </div>
        </div>
      </Content>
    </Container>
  </Wrapper>
);

export default About;
